import React from 'react';
import { FileText, BookOpen, BookMarked, BookOpenCheck, Clock } from 'lucide-react';
import { getTemplateIcon } from './templateIcons';
import { 
  TEMPLATE_TYPE_NAMES, 
  TEMPLATE_DESCRIPTIONS, 
  TemplateType 
} from '@/constants/templateTypes';

interface TemplateInfo {
  icon: React.ReactNode;
  name: string;
  description: string;
}

interface LengthTagInfo {
  icon: React.ReactNode;
  description: string;
}

/**
 * Gets template information including icon, name, and description
 */
export const getTemplateInfo = (template: string): TemplateInfo => {
  if (!template) return {
    icon: <FileText className="h-3 w-3 mr-1" />, 
    name: '', 
    description: 'Standard article format'
  };
  return {
    icon: getTemplateIcon(template),
    name: TEMPLATE_TYPE_NAMES[template as TemplateType] || template,
    description: TEMPLATE_DESCRIPTIONS[template as TemplateType] || 'Standard article format'
  };
};

/**
 * Gets length tag information including icon
 */
export const getLengthTagInfo = (tag: string): LengthTagInfo => {
  if (!tag) return {
    icon: <FileText className="h-3 w-3 mr-1" />,
    description: 'Standard length article'
  };
  
      switch (tag.toLowerCase()) {
      case 'ultra-short':
        return {
          icon: <Clock className="h-3 w-3 mr-1" strokeWidth={1.5} />,
          description: '0-300 words'
        };
      case 'short':
        return {
          icon: <Clock className="h-3 w-3 mr-1" strokeWidth={1.5} />,
          description: '300-600 words'
        };
      case 'medium':
        return {
          icon: <Clock className="h-3 w-3 mr-1" strokeWidth={1.5} />,
          description: '600-900 words'
        };
      case 'medium-long':
        return {
          icon: <BookOpen className="h-3 w-3 mr-1" strokeWidth={1.5} />,
          description: '900-1200 words'
        };
      case 'long':
        return {
          icon: <BookOpen className="h-3 w-3 mr-1" strokeWidth={1.5} />,
          description: '1200-1800 words'
        };
      case 'very-long':
        return {
          icon: <BookOpen className="h-3 w-3 mr-1" strokeWidth={1.5} />,
          description: '1800+ words'
        };
    default:
      return {
        icon: <FileText className="mr-1" />,
        description: tag.charAt(0).toUpperCase() + tag.slice(1).replace(/-/g, ' ')
      };
  }
}; 